/* eslint react/jsx-props-no-spreading: off */ // --> eslint says prop spreading fine for HOC

import MUIButton, { ButtonProps } from "@mui/material/Button";

export function Button(props: ButtonProps) {
    return <MUIButton {...props} />;
}